import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend'; // Load translations via HTTP
import LanguageDetector from 'i18next-browser-languagedetector'; // Auto-detect user language

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en', // Default language
    debug: true, // Set to false in production
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Translation files location
    },
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
    saveMissing: false, // Set to true if you want to send missing keys to the server
    parseMissingKeyHandler: (key) => {
      console.warn(`Missing translation key: "${key}"`);
      return key; // Fallback to the key itself (optional)
    },
  });

export default i18n;
